module.exports = __webpack_public_path__ + "img/_video.9a501c9a.svg";